import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExecutionFlagFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";

/**
 * A list of flags that can be used in operators and operands to modify their behavior.
 * @export
 * @interface ExpExecutionFlag
 */

export class ExpExecutionFlagFactory {}
_ExpExecutionFlagFactory = ExpExecutionFlagFactory;
_defineProperty(ExpExecutionFlagFactory, "FromJSON", function (json) {
  return _ExpExecutionFlagFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExecutionFlagFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'icon': json['icon'],
    'label': json['label'],
    'description': json['description'],
    'sortPriority': json['sortPriority'] === undefined ? 0 : json['sortPriority'],
    'valueTypeIDs': json['valueTypeIDs'] === null || json['valueTypeIDs'] === undefined ? json['valueTypeIDs'] : json['valueTypeIDs'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData'])
  };
});
_defineProperty(ExpExecutionFlagFactory, "ToJSON", function (value) {
  return _ExpExecutionFlagFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExecutionFlagFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'icon': value.icon,
    'label': value.label,
    'description': value.description,
    'sortPriority': value.sortPriority,
    'valueTypeIDs': value.valueTypeIDs,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData)
  };
});
//# sourceMappingURL=ExpExecutionFlag.js.map
